<template>
    <router-link :to="'/categories/' + category.id" active-class="active" class="nav-link py-2 cgi-category-item-container">
        <span class="category-icon ml-0"><icon icon="clipboard"/></span> 
        <span class="category-name">{{category.title}}</span> 
        <span v-if="categoryStatuses.length > 0" class="status-icon mr-0">
            <!-- <icon v-bind:class="[getCategoryStatus(category.id) > 0 ? 'btn-success active' : 'btn-secondary' ]" /> -->
            <icon v-if="getCategoryStatus(category.id) == 1" class="status-danger" icon='exclamation' />
            <icon v-else-if="getCategoryStatus(category.id) == 2" class="status-success" icon='check' />
            <icon v-else-if="getCategoryStatus(category.id) == 3" class="status-warning" icon='spinner' />
        </span>
    </router-link>
</template>

<script>
export default {
    props: {
        category: Object
    },
    computed: {
        categoryStatuses() {
            return this.$store.getters.categoryStatuses;
        },
    },
    methods: {
        getCategoryStatus: function(categoryId) {
            return this.categoryStatuses[this.categoryStatuses.map(function (item) {return item.categoryId}).indexOf(categoryId)].status;
        }
    }
}
</script>

<style lang="scss">
    .cgi-category-item-container{
        span {
            margin: auto;
            &.category-icon {
                font-size: 18px !important;
            }
            &.category-name {
                // font-size: 20px;
                margin-left: 5px;
            }
            &.status-icon {
                svg{
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    color: white;
                    padding: 2px;
                }
                //line-height: 17px;
                float: right;
                .status-success {
                    background: #1cc88a;
                    border: 1px solid #14aa73;
                }
                .status-danger {
                    background: #f52323;
                    border: 1px solid #cc1414;
                }
                .status-warning {
                    background: #ffc107;
                    border: 1px solid #f0ad4e;
                }
            }
        }
    }
</style>